export default {
    list: {
        title: "Salaries",
        name: 'salaries',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        sousTable: true,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                name: "Actions",
                buttons: [{
                        text: "New salaries",
                        icon: "add",
                        link: '/salaries/generate',
                        color: 'primary'
                    }
                ],
            }
        },
        columns: [
            {
                name: "Salarie ID",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "id",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Employeur",
                elements: [{
                    items: [{
                        class: "",
                        name: "user",
                        elements: [{
                            items: [{
                                name: "fullName",
                                class: "font-bold text-gray-700",
                                icone: "contacts"
                            },
                            {
                                name: "username",
                                class: "font-light text-gray-700",
                                icone: "copyright"
                            }
                        ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "Role",
                elements: [{
                    items: [{
                        class: "",
                        name: "user",
                        elements: [{
                            items: [{
                                name: "type",
                                class: "font-bold text-gray-700",
                                icone: ""
                            },
                            // {
                            //     name: "type",
                            //     class: "font-light text-gray-700",
                            //     icone: ""
                            // }
                        ]
                        }]

                    }, ],
                }, ]
            },
          
            {
                name: "Salaire",
                class: "",
                elements: [{
                    items: [{
                        class: "font-bold",
                        name: "amount",
                        type: "text",
                    }],
                }, ]
            },

            
            {
                name: "Période",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        periode: true,
                        name: "periode",
                        type: "text",
                    }],
                }, ]
            },
           
            {
                name: "Date creation",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "date",
                        type: "text",
                    }],
                }, ]
            },


            
        ],
        actions: {
            name: "Actions",
            width: "10px",
            class: "justify-end",
            elements: [
                {
                    icone: "print",
                    color: "success",
                    key: 'print',
                    role: true,
                    id: "",
                    tooltip: "Print",
                },
                {
                    icone: "remove_red_eye",
                    color: "success",
                    key: 'read',
                    id: "",
                    role: true,
                    link: '/salaries/view',
                    tooltip: "Update",
                },
            ],
        },
        filters: {
            name: 'salaries',
            hasFilterdate:true,
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "SALARIE ID ...",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [
                    {
                        label: "Roles",
                        key: "type",
                        name: "name",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Employeurs",
                        key: "user",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                   
                    {
                        label: "Date creation",
                        key: "Range_date",
                        value: null,
                        placeholder: "Date Range ...",
                        type: "date_range",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full"
                    },
                ],
            },
        },
    },
}
